import { SimpleModal } from '@livable/saas-react-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import { RefundForm } from './RefundForm';
import { VoidRefundForm } from './VoidRefundForm';
import { TRANSACTION_TYPES } from 'src/constants/payments';
const RefundModal = _ref => {
  let handleClose = _ref.handleClose,
    isOpen = _ref.isOpen,
    triggerRefresh = _ref.triggerRefresh,
    setTriggerRefresh = _ref.setTriggerRefresh;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const isRefund = store.transaction.refundType === TRANSACTION_TYPES.Refund;
  const isVoid = store.transaction.refundType === TRANSACTION_TYPES.Void;
  const getTitle = () => {
    if (isRefund) return t("resident_account.process_refund");
    if (isVoid) return t("resident_account.process_void");
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: handleClose,
    isOpen: isOpen,
    noFooter: true,
    noPadding: true,
    title: getTitle()
  }, !!isRefund && /*#__PURE__*/React.createElement(RefundForm, {
    triggerRefresh: triggerRefresh,
    setTriggerRefresh: setTriggerRefresh
  }), !!isVoid && /*#__PURE__*/React.createElement(VoidRefundForm, {
    triggerRefresh: triggerRefresh,
    setTriggerRefresh: setTriggerRefresh
  }));
};
export default RefundModal;